<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Merchant Report</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Report Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Merchant Report Setup</h4>
          <p class="sub-header">
            Setup merchants for your current participant
          </p>

          <div class="row" *ngIf="canManage">
            <div class="col-12 d-flex justify-content-end">
              <button type="button" class="btn btn-icon btn-outline-primary mx-1" (click)="registerMerchant()">
                <i class="mdi mdi-content-copy"></i>
                Register merchant
              </button>

              <button type="button" class="btn btn-icon btn-outline-primary mx-1" (click)="manageUsers()">
                <i class="mdi mdi-content-copy"></i>
                Link user to merchant
              </button>

              <button type="button" class="btn btn-icon btn-outline-primary mx-1" (click)="SyncMerchants()">
                <i class="mdi mdi-content-copy"></i>
                Sync merchants
              </button>
            </div>
          </div>
          <br />

          <div class="col-12">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
              <thead>
                <tr>
                  <th>USN Number</th>
                  <th>Merchant number</th>
                  <th>Participant</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let merchant of merchants">
                  <td>{{ merchant.usnNumber }}</td>
                  <td>{{ merchant.merchantNumber }}</td>
                  <td>{{ merchant.participantId }}</td>
                  <td>
                    <button type="button" *ngIf="canManage" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="editMerchant(merchant)">
                      <i class="mdi mdi-pencil-box-outline"></i>
                      manage merchant
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="merchants?.length == 0">
                <tr>
                  <td colspan="6" class="no-data-available">No merchants available to display!</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> <!-- end container -->
